module.exports = __webpack_public_path__ + "assets/images/numberofChairs-02.29fb730de7af6edb0cb26bed36d7e1d5.svg";